import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
let ResultPage = class ResultPage extends Vue {
    tagIndex;
    pageSize;
    imgList;
    isCheck;
    resultType;
    isWidth;
    isBorder = true;
    activeBorderColor = colors.boardItemHover;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    selectionList = [];
    eventType = '';
    showPath = true;
    loading = false;
    checked = [];
    disabled = false;
    get returnPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
    mounted() { }
    current(page) {
        this.$emit('pageSize', page);
    }
    openDetail(data, index) {
        this.$emit('open-detail', data, index);
    }
    changeChecked(val, deviceVal, index) {
        this.$emit('change-track', val, deviceVal, index);
    }
};
__decorate([
    Prop({ default: 0, type: Number })
], ResultPage.prototype, "tagIndex", void 0);
__decorate([
    Prop()
], ResultPage.prototype, "pageSize", void 0);
__decorate([
    Prop()
], ResultPage.prototype, "imgList", void 0);
__decorate([
    Prop()
], ResultPage.prototype, "isCheck", void 0);
__decorate([
    Prop({ default: true })
], ResultPage.prototype, "resultType", void 0);
__decorate([
    Prop({ default: false })
], ResultPage.prototype, "isWidth", void 0);
ResultPage = __decorate([
    Component({
        name: 'ResultPage',
        components: { BlurPicture },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], ResultPage);
export default ResultPage;
